<script setup lang="ts">
import {
  getAllCategories,
  getCharactersByCategory,
} from "@/utils/specialCharacters";

const { t } = useI18n();

withDefaults(
  defineProps<{
    open: boolean;
  }>(),
  { open: false }
);

const emit = defineEmits(["hide", "hidden", "insert"]);
const handleHide = () => {
  emit("hide");
};

const categories = computed(() => getAllCategories());

const specialCharacters = computed(() => {
  return getCharactersByCategory()[currentCategory.value];
});

const currentCategory = ref<string>("Mathematical Operators");
const currentCharacter = ref<string>();

const handleInsert = () => {
  emit("insert", currentCharacter.value);
};
</script>
<template>
  <teleport to="body">
    <BaseModal size="md" :open="open" @hide="handleHide" @hidden="handleHide">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ t("wysiwyg.specialCharactersModal.header") }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body bg-white">
        <BaseSelect
          id="category"
          v-model="currentCategory"
          :show-label="false"
          label="Category"
        >
          <option
            v-for="category in categories"
            :key="category"
            :value="category"
          >
            {{ t(`wysiwyg.specialCharactersModal.categories.${category}`) }}
          </option>
        </BaseSelect>

        <div class="character-grid">
          <a
            v-for="character in specialCharacters"
            :key="character"
            href="#"
            type="button"
            class="character-item"
            :class="{ active: currentCharacter === character }"
            @click.prevent="currentCharacter = character"
          >
            {{ character }}
          </a>
        </div>
      </div>
      <div class="modal-footer">
        <a href="#" class="btn text-decoration-none" data-bs-dismiss="modal">{{
          t("buttons.cancel")
        }}</a>
        <button
          data-bs-dismiss="modal"
          aria-label="Close"
          class="btn btn-primary btn-rounded"
          @click="handleInsert"
        >
          {{ t("buttons.insert") }}
        </button>
      </div>
    </BaseModal>
  </teleport>
</template>

<style scoped lang="scss">
.character-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(36px, 1fr));
  gap: 2px;
}

.character-item {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: $body-color;
  font-size: 1.2rem;
  background-color: $color-white;
  border: 1px solid $border-color;

  &:hover,
  &.active {
    border-color: $primary;
    background-color: $brand-tools-light;
  }
}
</style>
